<template>
    <div>
        <div class="head">
            <img src="../../assets/sjzm_1.jpg"/>
            <img src="../../assets/sjzm_2.jpg"/>
            <img src="../../assets/sjzm_3.jpg"/>
            <img src="../../assets/sjzm_4.jpg"/>
        </div>
         <div class="title">
                <img src="../../assets/line_b.png"/>
                <span>基本要求</span>
        </div>
        <div class="container">
            <p>1. 3年安全驾驶；</p>
            <p>2. 年龄23-55周岁；</p>
            <p>3. 无违法犯罪记录、无精神病史、无吸毒史及平台认为不适合代驾的其他历史证明；</p>
            <p>4. 有熟练驾车经验；</p>
            <p>5. 身体健康，无肢体残疾及大面积纹身；</p>
            <p>6. 需提供身份证、驾驶证、本人借记卡、直系亲属联系方式，并保证前述证明材料的真实合法性。</p>
        </div>
        <div class="title">
                <img src="../../assets/line_b.png"/>
                <span>招募流程</span>
        </div>
        <div class="container">
            <img src="../../assets/sjzm_5.jpg"/>
            <ul><li><span>1</span></li><li><p class="sub-title">在线报名</p><p class="sub-content">本人手机号注册，确认工作城市</p> </li></ul>
            <ul><li><span>2</span></li><li><p class="sub-title">招募答题</p><p class="sub-content">答题形式检验司机基础驾驶知识</p> </li></ul>
            <ul><li><span>3</span></li><li><p class="sub-title">基本信息提交</p><p class="sub-content">按流程提交本人身份证、驾驶证照片</p> </li></ul>
            <ul><li><span>4</span></li><li><p class="sub-title">信息审核</p><p class="sub-content">对提交信息及证据进行审核（具体以注册城市分公司为准）</p> </li></ul>
            <ul><li><span>5</span></li><li><p class="sub-title">面试</p><p class="sub-content">线下一对一沟通，了解信息及解答问题</p> </li></ul>
            <ul><li><span>6</span></li><li><p class="sub-title">路考</p><p class="sub-content">线下考核司机驾驶技术</p> </li></ul>
            <ul><li><span>7</span></li><li><p class="sub-title">签约加盟</p><p class="sub-content">线下校验司机身份信息，通过后完成签约开通账号并领取司机物料</p> </li></ul>
            <ul><li><span>8</span></li><li><p class="sub-title">培训上线</p><p class="sub-content">培训司机服务相关的理论及演练服务</p> </li></ul>
        </div>
         <div class="title">
                <img src="../../assets/line_b.png"/>
                <span>基础知识</span>
        </div>
        <div class="container1">
             <div class="title1">
                <img src="../../assets/line_g.png"/>
                <span>软件的下载与使用</span>
                <div>
                    签约后，可通过公众号“{{terantInfo.brandName}}代驾司机服务平台”下载司机端，使用签约手机号进行登录，工作台首页点击“上线听单”按钮进行听单；接到订单后，根据服务流程在司机端进行对应操作，直至代驾服务完成。
                </div>
            </div>
              <div class="title1">
                <img src="../../assets/line_g.png"/>
                <span>服务规范</span>
                <div>
                    代驾过程中需要按照{{terantInfo.brandName}}代驾服务规范标准进行服务，接单前准备好所需物料、穿平台统一标识服装并佩戴头盔，同时保持服装整洁无异味，接单后需在30秒内联系用户并及时前往约定地点，按标准提供服务，为用户提供优质的服务体验。
                </div>
            </div>
              <div class="title1">
                <img src="../../assets/line_g.png"/>
                <span>平台规则</span>
                <div>
                    司机账号拥有12分初始代驾分，当违反平台规则时，将根据标准扣除对应的代驾分，当代驾分扣为0分时则平台将与司机解除合作。代驾分未扣至0分前，自签约日起，司机每服务满1年，将按照代驾次数进行回分，代驾分封顶12分。
                </div>
            </div>
              <div class="title1">
                <img src="../../assets/line_g.png"/>
                <span>司机收入预期</span>
                <div>
                    司机收入与订单收益挂钩，基本原则为多劳多得、不劳不得，会受城市、在线时长、上线区域等因素影响，以北京某师傅为例：月上线时间200小时，且高峰时段经常上线，月收入在9000元左右。
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data(){
    return {
    }
  },
  computed: {
    ...mapGetters({
      terantInfo:'getTerantInfo'
    })
  }
}
</script>
<style lang="scss" scoped>
.head{
    img{
        width: 100%;
        height: auto;
        vertical-align: bottom;
    }
}
.title{
        width: 100%;
        font-size: .44rem;
        margin: 1rem 0 .5rem 0;
        img{
            width: .12rem;
            height: .48rem;
            margin: 0;
            padding: 0;
            vertical-align: bottom;
        }
        span{
            font-size: .44rem;
            color: #19191A;
            font-weight: bold;
            margin-left:0.18rem;
        }
    }
    .container1{
        width: 88%;
        // margin-left: 3%;
        padding: 0 6% 0.2rem 6%;
        .title1{
        width: 100%;
        font-size: .44rem;
        img{
            width: .18rem;
            height: .25rem;
            margin: 0;
            padding: 0;
            // vertical-align: bottom;
        }
        span{
           font-size: .28rem;
            color: #00A0E9;
            font-weight: bold;
        }
        div{
            margin: .18rem 0 .44rem 0;
            font-size: .24rem;
            color: #727275;
            line-height: .36rem;
        }
    }
    }
.container ul:last-child{
    border:none
}
.container{
    font-size: .28rem;
    color: #19191A;
    width: 88%;
    // margin-left: 3%;
    padding: 0 6% 0 6%;
    img{
        width: 100%;
        margin-bottom: .54rem;
    }
    p{
       font-size: .28rem;
        color: #727275;
        line-height: .52rem;
    }
    ul li:first-child{
        width: 10%;
        text-align: left;
        float: left;
        span{
            background: #19191A;
            width: .36rem;
            height: .36rem;
            line-height: .36rem;
            border-radius: 50%;
            display: inline-block;
            color: #fff;
            text-align: center;
            position: relative;
            left: -.16rem;
            font-size: .24rem;
        }
    }
    ul li:last-child{
        margin-top: -0.03rem;
        margin-left: -0.2rem;
        width: 90%;
        text-align: left;
        float: left;
        .sub-title{
            color: #19191A;
            font-size: 0.28rem;
            font-weight: 700;
        }
        .sub-content{
            color: #727275;
            font-size: 0.24rem;
        }
    }
    li{
        line-height: .36rem;
        display: inline-block;
    }
    ul{
        border-left: .02rem rgba(0, 0, 0, 0.5) solid;
        padding-bottom: .42rem;
        margin-left: 0.16rem;
    }
    ul:last-child{
        padding-bottom: 0;
    }
    ul:after{
        content: '';
        display: block;
        clear: both;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/without-page/index.vue